<template>
  <v-dialog v-model="getdialog" max-width="900" persistent>
    <v-card class="contactus">
      <div class="contact-grid-container">
        <div class="item1" style="overflow: hidden">
          <div style="position: relative" class="icon-main-box">
            <div class="h1box">
              <div class="h1">Contact Us</div>
            </div>
            <div>
              <div class="font-16 my-4">
                <b> Customer Service </b>
              </div>
              <!-- <div class="font-16">
                <span style="color: rgba(34, 34, 34, 0.7)">
                  2750 Stickney Point Rd. Suite #203 Sarasota, Florida 34231 USA
                </span>
              </div> -->
              <div class="font-16 my-4">
                <v-icon class="mr-3">mdi-phone</v-icon>
                <span style="color: rgba(34, 34, 34, 0.7)">
                  877-519-9119 (US only)
                </span>
              </div>
              <div class="font-16 my-4">
                <v-icon class="mr-3">mdi-phone</v-icon>
                <span style="color: rgba(34, 34, 34, 0.7)">
                  +1 941-921-7443 (Global)
                </span>
              </div>
              <div class="font-16 my-4">
                <v-icon class="mr-3">mdi-clock</v-icon>
                <span style="color: rgba(34, 34, 34, 0.7)">
                  M-Th, 9am – 5pm Eastern, USA
                </span>
              </div>
              <div class="font-16 my-4 d-flex" @mouseover="changeCursor(true)" @mouseleave="changeCursor(false)">
                <v-icon class="mr-3">mdi-email</v-icon>
                <p style="color: rgba(34, 34, 34, 0.7)" class="ma-0 pa-0" :style="{ cursor: isHovering ? 'pointer' : 'auto' }" >
                 <span class="primary--text ma-0 pa-0" @click="redirectEmail('office@bodytalksystem.com')"
                    >office@bodytalksystem.com</span
                  >
                </p>

              </div>
              <v-divider class="divider"></v-divider>
            </div>

            <div>
              <div class="heading1 d-flex my-6">Corporate Office</div>
              <div class="font-16">
                <span style="color: rgba(34, 34, 34, 0.7)">
                  1079 N. Tamiami Trail #112<br />
                  Nokomis, Florida<br />
                  34275, USA<br />
                  <!-- <span class="primary--text text-decoration-underline"  @click="redirectToSkype" >
                    941-921-7443</span
                  > -->
                   <a :href="'tel:' + phoneNumber" class="primary--text text-decoration-underline">941-921-7443</a>
                </span>
              </div>
              <v-divider class="divider my-6"></v-divider>
            </div>

            <div>
              <div class="heading1 d-flex my-6">Newsletter</div>
              <div class="font-16">
                <span style="color: rgba(34, 34, 34, 0.7)">
                  Receive news and updates regarding our 
                  courses and philosophy by subscribing 
                  to the IBA Newsletter.
                </span>
              </div>
              <div class="my-3">
                <v-btn
                  depressed
                  color="primary"
                  @click="signupdialog = true"
                >
                  Sign Up
                </v-btn>
              </div>
              <v-dialog v-model="signupdialog" max-width="550">
                <v-card class="">
                  <signupnesletter />
                </v-card>
              </v-dialog>

              <!-- <router-link
                to="/register"
                class="link"
                style="z-index: 1"
                v-if="!isLoggedIn"
              >
                <div>Sign Up</div>
              </router-link> -->
              <!-- <router-link
                to="/profile/newsletter"
                class="link"
                style="z-index: 1"
                v-if="isLoggedIn"
              >
                <div>Sign Up</div>
              </router-link> -->
            </div>
          </div>

          <div class="icons-box">
            <v-row>
              <v-col cols="6">
                <div class="mt-n8">
                  <v-img src="img/icons/icon-2.png" width="70"></v-img>
                </div>
              </v-col>
              <v-col cols="6" class="d-flex justify-end">
                <div class="mt-n11">
                  <v-img src="img/icons/icon-8.png" width="70"></v-img>
                </div>
              </v-col>
            </v-row>
            <div class="d-flex justify-center">
              <v-row>
                <v-col cols="6" class="d-flex justify-center">
                  <div class="">
                    <v-img src="img/icons/icon-7.png" width="70"></v-img>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex justify-start">
                  <div class="">
                    <v-img src="img/icons/icon-3.png" width="70"></v-img>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="item2">
          <div class="d-flex justify-end mt-4">
            <v-icon @click="closedialog">mdi-close</v-icon>
          </div>
          <div class="item2" style="overflow: hidden">
            <!-- <div class="d-flex justify-end mt-4">
              <v-icon @click="closedialog">mdi-close</v-icon>
            </div> -->
            <div class="h1box">
              <div class="font-24"><b> 
                <div :class="{ notranslate: getFlag === 'Japanese' }" v-if="getFlag === 'Japanese'">
                  質問がありますか？
                </div>
                <div v-else><ChangeLanguageComponent
                  :langName="languageObject.HaveQuestion"
                /></div>
              </b></div>
            </div>
            <div>
              <div class="font-16 mb-9">
                <span style="color: rgba(34, 34, 34, 0.7)">
                  Send us a message by filling out the form below. One of our
                  representatives will respond to you shortly.
                </span>
              </div>
            </div>

            <form @submit.prevent="submit">
              <div
                class="form-group pt-1 mb-2"
                :class="{ 'form-group--error': $v.form.fname.$error }"
              >
                <v-text-field
                  hide-details
                  :label="getLabel('FirstName')"
                  v-model="form.fname"
                  :error="$v.form.fname.$error"
                ></v-text-field>
                <div></div>

                <div class="v-application .error" v-if="$v.form.fname.$error">
                  <span class="text_warnig"> Please enter <ChangeLanguageComponent :langName="languageObject.firstname" /></span>
                </div>
              </div>
              <div
                class="form-group pt-1 mb-2"
                :class="{ 'form-group--error': $v.form.lname.$error }"
              >
                <v-text-field
                  hide-details
                  :label="getLabel('LastName')"
                  v-model="form.lname"
                  :error="$v.form.lname.$error"
                ></v-text-field>
                <div></div>

                <div class="v-application .error" v-if="$v.form.lname.$error">
                  <span class="text_warnig"> Please enter <ChangeLanguageComponent :langName="languageObject.lastname" /></span>
                </div>
              </div>
              <div
                class="form-group pt-1 mb-2"
                :class="{ 'form-group--error': $v.form.email.$error }"
              >
                <v-text-field
                  hide-details
                  label="Email Address *"
                  v-model="form.email"
                  :error="$v.form.email.$error"
                  placeholder="youremail@gmail.com"
                ></v-text-field>
                <div></div>

                <div class="v-application .error" v-if="$v.form.email.$error">
                  <span class="text_warnig"> Please enter email address</span>
                </div>
              </div>
              <div
                class="form-group pt-1 mb-2"
                :class="{ 'form-group--error': $v.form.phoneNumber.$error }"
              >
                <v-text-field
                  hide-details
                  :label="getLabel('mobileNumber')"
                  v-model="form.phoneNumber"
                  :error="$v.form.phoneNumber.$error"
                >
                </v-text-field>
                  

                <div
                  class="v-application .error"
                  v-if="$v.form.phoneNumber.$error"
                >
                  <span class="text_warnig"> Please enter <ChangeLanguageComponent :langName="languageObject.mobilenumber" /></span>
                </div>
              </div>
              <v-textarea
                hide-details
                name="input-7-1"
                label="Leave us your message here..."
                single-line
                value=""
                v-model="form.message"
              ></v-textarea>
              <div
                  class="v-application .error"
                  v-if="$v.form.message.$error"
                >
                  <span class="text_warnig"> Email is required</span>
                </div>
              <v-btn
                class="button mt-5 mb-11"
                block
                height="50"
                color="primary"
                type="button"
                @click="submit"
              >
                <span v-if="btnloader != true">SEND MESSAGE</span>
                <v-progress-circular
                  indeterminate
                  v-show="btnloader"
                  color="white"
                  size="20"
                ></v-progress-circular>
              </v-btn>
            </form>
          </div>
        </div>
      </div>
      <!-- <v-btn color="green darken-1" text @click="closedialog">
          Agree
        </v-btn> -->
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import signupnesletter from "../../components/Contactus/signup_newsletter.vue";
import ChangeLanguageComponent from "../../components/HomePage/ChangeLanguage.Component.vue";
import languageObject from "../../utils/index";

export default defineComponent({
  name: "ContactUsComponent",
  components: { signupnesletter, ChangeLanguageComponent },
  mixins: [validationMixin],
  data() {
    return {
      languageObject,
      isHovering: false,
      phoneNumber:'941-921-7443',
      signupdialog: false,
      errorIcon: false as boolean,
      show1: false as boolean,
      btnloader: false,
      // password: "" as string,
      form: {
        GuestId: null,
        UserId: null,
        email: "" as string,
        fname: "" as string,
        lname: "" as string,
        phoneNumber: "" as string,
        message: "" as string,
        required,
      },
      submitStatus: "" as string,
    };
  },

  validations: {
    form: {
      email: { required, email },
      fname: { required },
      lname: { required },
      phoneNumber: { required },
      message: {required}
    },
  },
  computed: {
    ...mapGetters(["getdialog", "isLoggedIn", "getFlag","GetUserWeb"]),
  },
  methods: {
    changeCursor(value: boolean) {
      this.isHovering = value;
    },
    redirectToSkype() {
      window.location.href = "skype:123456789?call";
    },
    redirectEmail(email: string) {
      window.location.href = `mailto:${email}`;
    },
    closedialog() {
      this.$store.dispatch("ToggleContact", false);
      this.form.email = ""
      this.form.fname = ""
      this.form.lname = ""
      this.form.phoneNumber = ""
      this.form.message = ""
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
       
      } else {
        this.submitStatus = "PENDING";
        this.btnloader = true;
        this.form.GuestId = this.isLoggedIn ? null : localStorage.getItem("CartSession")?.toString();
        this.form.UserId = this.form.GuestId ? null : this.GetUserWeb?.Id;
        this.$store.dispatch("ContactUs", this.form).then((res)=>{
          
          if (res.Status) {
            this.form.email = ""
            this.form.fname = ""
            this.form.lname = ""
            this.form.phoneNumber = ""
            this.form.message = ""
            this.$v.$reset();
            this.btnloader = false;
            this.submitStatus = "OK";
            this.$store.dispatch("ToggleContact", false);
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Message sent successfully",
              showConfirmButton: false,
              timer: 2500,
            });
          } else {
            this.btnloader = false;
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              title: "Something went wrong",
              showConfirmButton: false,
              timer: 2500,
            });
          }
        })
        
      }
    },
    getLabel(wordKey) {
      const currentLanguage = localStorage.getItem('Flag') || 'English';
      const translation = this.languageObject[wordKey];
      // return translation ? translation[currentLanguage] : wordKey;
      if (translation) {
        return translation[currentLanguage] || translation['English'] || wordKey;
      } else {
        return wordKey;
      }
    }
  },
});
</script>
